<template>
	<div>
		<div :class="generalClasses">
			<label
				v-for="(item, index) in items"
				:key="item.value"
				:for="'option-' + index + indexItem"
				:class="labelMajorClasses"
			>
				<div class="display-flex container-radio align-items-center">
					<input
						type="radio"
						:id="'option-' + index + indexItem"
						:checked="value === item.value"
						:value="item.value"
						:name="name"
						@change="
							$event => {
								$emit('change', $event.target.value);
							}
						"
						@input="
							$event => {
								$emit('input', $event.target.value);
							}
						"
					/>
					<div class="font-size-big radio-icon margin-right-normal display-flex align-items-center">
						<b-icon class="blue-base" v-if="value === item.value">
							<icon-radio-button-checked class="icon" />
						</b-icon>
						<b-icon class="ink-lighter-1" v-else>
							<icon-radio-button-unchecked class="icon" />
						</b-icon>
					</div>
					<div :class="labelClasses" class="option" v-if="!!item.name" v-html="item.name"></div>
				</div>
			</label>
		</div>
		<span class="input-error font-size-big red-base margin-top-tiny" v-if="!!error">
			<b-icon>
				<icon-error />
			</b-icon>
			{{ error }}
		</span>
	</div>
</template>

<script>
import BIcon from './Icon.vue';

export default {
	name: 'b-radio',
	components: {
		BIcon
	},
	props: {
		/**
		 * Name do radio
		 */
		name: {
			type: String,
			required: true
		},
		/**
		 * Itens do radio
		 * @model
		 */
		items: {
			type: Array
		},
		/**
		 * Valor do radio
		 * @model
		 */
		value: {
			type: String,
			defaul: ''
		},
		/**
		 * Mensagem de erro
		 */
		error: {
			type: String,
			default: ''
		},
		/**
		 * Classes para estilizar a div acima do item do radio
		 */
		generalClasses: {
			type: String,
			default: ''
		},
		/**
		 * Classes para estilizar o label
		 */
		labelClasses: {
			type: String,
			default: 'font-size-big ink semi-bold'
		},
		/**
		 * Classes para estilizar todo o item do radio
		 */
		labelMajorClasses: {
			type: String,
			default: 'display-block margin-vertical-big'
		},
		/**
		 * Index a ser utilizado para o for
		 */
		indexItem: {
			type: String,
			default: '0'
		}
	}
};
</script>

<style scoped lang="scss">
input {
	display: none;
}
span.input-error {
	display: block;
	text-align: left;
	line-height: 1.2;
}
.container-radio {
	cursor: pointer;
}
.radio-icon {
	margin-top: 1px;
}
.radio-icon .icon {
	width: 2rem;
	height: 2rem;
}
.option {
	width: calc(100% - 20px);
	margin: 0px;
	padding: 0px;
	overflow-y: overflow;
}
</style>

<docs>
    BRadio
    ```js
    <b-radio class="margin-top-big" name="options" labelClasses="ink-lighter-1 font-size-big" v-model="selectedOption" :items="[{ name: 'Opção 1', value: 'option-1' }, { name: 'Opção 2', value: 'option-2' }]" />
    ```
</docs>
